module.exports = __webpack_public_path__ + "static/0-5cf1a176fd1cf9f946d98cdd572af20f.jpg";